import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Autocomplete } from "@mui/material";
import useBreakpoints from "../../hooks/useBreakpoints";
import { UseInstallmentOrderReport } from "./UseInstallmentOrderReport";
import moment from "jalali-moment";

export default function YearMonthOverview(props) {
  const { isSmall } = useBreakpoints();
  const [years, setYears] = useState([]);
  const [months, setMonths] = useState([]);
  const { GetYearOverview, GetMonthOverview } = UseInstallmentOrderReport();

  useEffect(() => {
    GetYearOverview((years) => {
      setYears(years.map((vP) => ({ ...vP, title: vP.id.toString() })));

      setYears(years);
    });
  }, []);

  useEffect(() => {
    if (props.state.year) {
      GetMonthOverview(props.state.year, (months) => {
        const today = new Date();
        const month = today.getMonth();
        // let month = months.find((m) => m.hasReport == true).id;
        const now = moment(); // تاریخ الآن به میلادی
        const jalaliDate = now.locale("fa").format("jM");
        props.setState({ ...props.state, month: jalaliDate });
        setMonths(months);
      });
    }
  }, [props.state.year]);

  return (
    <Box
      sx={{
        gap: 2,
        display: "flex",
        alignItems: "center",
        mb: 1,
        width: "100%",
      }}
    >
      <Typography variant="subtitle2">تاریخ :</Typography>
      {years && (
        <Autocomplete
          size="small"
          value={props.state.year ? props.state.year : ""}
          onChange={(event, newValue) => {
            if (newValue) {
              props.setState({ ...props.state, year: newValue });
            } else {
              props.setState({ ...props.state, year: "" });
            }
          }}
          isOptionEqualToValue={(option, value) => {
            return option === value;
          }}
          getOptionLabel={(option) => {
            if (option) {
              // return years?.find((m) => m.id == option)?.title;
              return (
                years?.find((m) => m.id == option)?.title || option.toString()
              );
            }
            return "";
          }}
          sx={{ width: isSmall ? "40%" : "20%" }}
          fullWidth
          options={years?.map((m) => m.id) || []}
          renderInput={(params) => (
            <TextField
              sx={{ input: { textAlign: "center" } }}
              variant="outlined"
              {...params}
              label="سال"
            />
          )}
        />
      )}
      {months && (
        <Autocomplete
          size="small"
          value={props.state.month ? props.state.month : ""}
          onChange={(event, newValue) => {
            if (newValue) {
              props.setState({ ...props.state, month: newValue });
            } else {
              props.setState({ ...props.state, month: "" });
            }
          }}
          isOptionEqualToValue={(option, value) => {
            return option === value;
          }}
          getOptionLabel={(option) => {
            if (option) {
              // return months?.find((m) => m.id == option)?.title;
              return (
                months?.find((m) => m.id == option)?.title || option.toString()
              );
            }
            return "";
          }}
          getOptionDisabled={(option) =>
            months?.find((m) => m.id == option)?.hasReport == false
          }
          sx={{ width: isSmall ? "40%" : "20%" }}
          fullWidth
          options={months?.map((m) => m.id) || []}
          renderInput={(params) => (
            <TextField
              sx={{ input: { textAlign: "center" } }}
              variant="outlined"
              {...params}
              label="ماه"
            />
          )}
        />
      )}
    </Box>
  );
}
